export enum FrontmanServices {
  wills = 'wills',
  studentLoans = 'studentloans',
  mortgage = 'mortgage',
  healthSavings = 'healthsavings',
  termLife = 'termlife',
  autoInsurance = 'autoinsurance',
  propertyCasualty = 'propertycasualty'
}
